import * as React from "react";
import {useParams} from "react-router-dom";


const CustomerStartSignDocument: React.FunctionComponent = () => {
    const {documentId, keyId, profileId, referTo} = useParams();

    let esignEndpoint = (window.location.protocol + '//' + window.location.hostname);
    if (window.location.hostname === "34.201.190.181") {
        esignEndpoint = "http://34.201.190.181:3005";
    }
    if (window.location.hostname === "localhost") {
        esignEndpoint = "http://localhost";
    }

    if (window.location.hostname === "test.promises12data.com" || window.location.hostname === "promises12data.com") {
        esignEndpoint = "https://esign.promises12data.com";
    }

    const doRedirect = () => {
        if (documentId && keyId && profileId) {
            window.location.href = esignEndpoint + "/c/" + profileId + "/" + documentId + "?document_key=" + keyId +
                "&redirect_uri=" + window.location.protocol + '//' + window.location.host + "/c/complete-document/" + referTo
        }
    }
    return <>
        <div className={"container"}>
            <div className={"row"}>
                <div className={"col-lg-12 mt-3 text-center"}>
                    <div className="row justify-content-md-center mb-3">
                        <img alt="logo" src="/assets/dist/img/promises12_logo.jpg"/>
                    </div>
                    {/*<h3>Loading document...</h3>*/}

                    {/*<div className="spinner-grow text-primary mt-3" role="status">*/}
                    {/*    <span className="sr-only">Loading...</span>*/}
                    {/*</div>*/}
                    <button className={"btn btn-primary mt-3"} type={"button"} onClick={() => {
                        doRedirect();
                    }}>Start Signing Document
                    </button>
                </div>
            </div>
        </div>
    </>
}

export default CustomerStartSignDocument;